<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div v-if="!isProcessing">
    <DiagCorpHeader
      :corpName="corpName"
      :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
      corporateSelectable="true"
      manageCorpName=""
      isAdmin="true"
      isDiagAvailablePlan="true"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    <DiagHeaderNavigation
      :answeredDiagResultItemsCountTotal="score"
      :diagItemsCountTotal="totalScore"
    ></DiagHeaderNavigation>

    <div class="l-contents">
      <DiagNavigation
        isAdmin=true
      ></DiagNavigation>
      <div class="l-contentsBox">
        <p class="l-pageTitle__sub">{{ diagResultItem.diagItem.diagSection.sectionNm }}「{{ diagResultItem.diagItem.diagSubSection.subSectionNm }}」</p>
        <h1 class="l-pageTitle">
          <span class="l-pageLabel">診断管理</span>
          <span class="number-text">
            <span class="number is-blue">{{ sortOrder }}.</span>
            <span class="text" style="white-space: pre-line;">{{ diagResultItem.diagItem.checkItem }}</span>
          </span>
        </h1>
        <div class="l-contentsSection">
          <div class="l-auditQustion">
            <div class="l-auditQustion__label">
              <dl class="l-auditQustion__status" v-if="!isIpo">
                <dt>リスク</dt>
                <dd>
                  <span class="label" :class="diagResultItem.diagItem.riskLevel.displayLabelClass" data-tooltip="" @mouseover="toggle(diagResultItem.diagResultItemId)" @mouseleave="toggleb(diagResultItem.diagResultItemId)">
                    <span class="tooltip is-right" :id="diagResultItem.diagResultItemId" >{{diagResultItem.diagItem.riskLevel.description}}</span>
                    {{ diagResultItem.diagItem.riskLevel.name }}
                  </span>
                </dd>
              </dl>
              <dl class="l-auditQustion__status" v-if="isIpo && !diagResultItem.diagItem.isMemo">
                <dt>IPO重要度</dt>
                <dd>
                  <span class="label-level" :class="diagResultItem.diagItem.ipoImportance.displayLabelClass" data-tooltip="" @mouseover="toggle(diagResultItem.diagResultItemId)" @mouseleave="toggleb(diagResultItem.diagResultItemId)">
                    <span class="tooltip is-right" :id="diagResultItem.diagResultItemId" >{{diagResultItem.diagItem.ipoImportance.description}}</span>
                    {{ diagResultItem.diagItem.ipoImportance.name }}
                  </span>
                </dd>
              </dl>
            </div>
          </div>
        </div>

        <div class="l-contentsSection" v-if="!(isIpo && diagResultItem.diagItem.isMemo)">
          <div class="l-grayBox">
            <div>
              <h4 class="l-headding is-small has-icon"><img src="@/assets/img/common/icon-point.svg" alt="" class="icon">ヒント</h4>
              <p class="l-text" style="white-space: pre-line;">{{ diagResultItem.diagItem.remediation }}</p>
            </div>
          </div>
        </div>

        <div class="l-contentsSection">
          <div class="l-contentsGrid2" v-if="!(isIpo && diagResultItem.diagItem.isMemo)">
            <div class="l-contentsGrid2__item" style="width:100%;margin-right:0px;">
              <div style="width:50%;">
                <div class="l-formGroup">
                  <label class="l-formGroup__label">回答</label>
                  <RadioButton :options="selectList" v-model="diagResultItem.itemVal" @input="() => isAnswerChanged = true"></RadioButton>
                </div>
              </div>
              <div>
                  <div class="l-grayBox mt-15">
                    <label class="l-checkbox is-bold" :class="{ 'is-selected' : diagResultItem.verifiedByLaborConsultant }">
                      <input type="checkbox"
                        v-model="diagResultItem.verifiedByLaborConsultant"
                        @input="() => isAnswerChanged = true"> 専門家の確認
                        <span class="icon-help" data-tooltip="" @mouseover="toggle('question_'+diagResultItem.diagResultItemId)" @mouseleave="toggleb('question_'+diagResultItem.diagResultItemId)">
                          <span class="tooltip is-right" :id="'question_'+diagResultItem.diagResultItemId" >クライアント法人が回答した項目は専門家ユーザーとして承認を行ってください。「専門家の確認」にチェックを行わないと、回答内容が監査結果に反映されません。</span>
                          <img src="@/assets/img/common/icon-help.svg" alt="" width="16px">
                        </span>
                    </label>
                  </div>
              </div>
            </div>

            <div class="l-contentsGrid2__item" style="width:100%;">

              <div style="width:50%;" v-if="diagResultItem.diagItem.sampleComment != null && diagResultItem.diagItem.sampleComment.length > 0">
                <div class="l-contentsMemo__title">
                  <label class="l-formGroup__label">現状/課題</label>
                  <button v-if="!isRemarksEditable" class="link-arrow" @click="changeRemarksEditable(true)">編集する</button>
                  <button v-if="isRemarksEditable" class="link-arrow" @click="changeRemarksEditable(false)">編集を終わる</button>
                </div>

                <div v-if="!isRemarksEditable" class="l-contentsMemo__body" style="padding-right:50px;">
                  <div class="l-grayBox is-normal auto-height" style="height:300px;">
                    <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink($v.diagResultItem.$model.remarks)"></p>
                  </div>
                </div>

                <div v-if="isRemarksEditable" class="l-formGroup"  style="padding-right:50px;">
                  <textarea class="auto-height l-formGroup__textArea is-edit" style="height:300px;" v-model="$v.diagResultItem.$model.remarks" @input="() => isAnswerChanged = true"></textarea>
                </div>
                <ValidationErrorMessage v-show="$v.diagResultItem.remarks.$error && !$v.diagResultItem.remarks.maxLength" validation="maxLength" valueLength="500" />

                <!--【例文あり】参考資料URLを「対応条文/e-Gov」の上に(現状/課題と同じ幅=padding-right:50px) ※標準版・IPO版共通-->
                <div class="mt-20" style="padding-right:50px;">
                  <div class="l-contentsMemo">
                    <div class="l-formGroup">
                      <div class="l-contentsMemo__title">
                        <label class="l-formGroup__label">参考資料URL</label>
                        <button v-if="!urlForms[0].viewFlag" class="link-arrow" @click="changeForm(true)">編集する</button>
                        <button v-else class="link-arrow" @click="changeForm(false)">編集を終わる</button>
                      </div>
                      <div v-for="(form, index) in urlForms" :key="index">
                        <div v-if="!urlForms[index].viewFlag" class="l-contentsMemo__body">
                          <div class="l-grayBox">
                            <p class="l-text" style="white-space: pre-line;" v-html="repalceLink(urlForms[index].content)"></p>
                          </div>
                        </div>
                        <TextArea v-if="urlForms[index].viewFlag" class="l-formGroup__textArea" v-model="urlForms[index].content" @input="() => isAnswerChanged = true"></TextArea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-20">
                  <div class="btn-basic is-middle is-inlne" @click="showEgovProvision(true)" :class="{'gray-out': !diagResultItem.diagItem.provisionsDetail}">
                    <a :class="{'gray-out': !diagResultItem.diagItem.provisionsDetail}">対応条文 e-Gov</a>
                  </div>
                  <div class="btn-basic is-middle is-inlne" @click="downloadGuideFile()" :class="{'gray-out': !diagResultItem.diagItem.guideCd}">
                    <a :class="{'gray-out': !diagResultItem.diagItem.guideCd}">ガイド</a>
                  </div>
                </div>
                <!--参考資料 end-->

              </div>

              <!-- 【例文なし】現状/課題(左 50%) ※標準版・IPO版共通 -->
              <div style="width:50%;" v-if="(diagResultItem.diagItem.sampleComment == null || diagResultItem.diagItem.sampleComment.length == 0)">
                <div class="l-contentsMemo__title">
                  <label class="l-formGroup__label">現状/課題</label>
                  <button v-if="!isRemarksEditable" class="link-arrow" @click="changeRemarksEditable(true)">編集する</button>
                  <button v-if="isRemarksEditable" class="link-arrow" @click="changeRemarksEditable(false)">編集を終わる</button>
                </div>

                <div v-if="!isRemarksEditable" class="l-contentsMemo__body" style="padding-right:50px;">
                  <div class="l-grayBox is-normal auto-height" style="height:300px;">
                    <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink($v.diagResultItem.$model.remarks)"></p>
                  </div>
                </div>

                <div v-if="isRemarksEditable" class="l-formGroup"  style="padding-right:50px;">
                  <textarea class="auto-height l-formGroup__textArea is-edit" style="height:300px;" v-model="$v.diagResultItem.$model.remarks" @input="() => isAnswerChanged = true"></textarea>
                </div>
                <ValidationErrorMessage v-show="$v.diagResultItem.remarks.$error && !$v.diagResultItem.remarks.maxLength" validation="maxLength" valueLength="500" />

                <div class="mt-20">
                  <div class="btn-basic is-middle is-inlne" @click="showEgovProvision(true)" :class="{'gray-out': !diagResultItem.diagItem.provisionsDetail}">
                    <a :class="{'gray-out': !diagResultItem.diagItem.provisionsDetail}">対応条文 e-Gov</a>
                  </div>
                  <div class="btn-basic is-middle is-inlne" @click="downloadGuideFile()" :class="{'gray-out': !diagResultItem.diagItem.guideCd}">
                    <a :class="{'gray-out': !diagResultItem.diagItem.guideCd}">ガイド</a>
                  </div>
                </div>
              </div>

              <!-- 【例文なし】参考資料URL(右 50%。現状/課題と同じ幅で横並び) ※標準版・IPO版共通 -->
              <div style="width:50%;" v-if="(diagResultItem.diagItem.sampleComment == null || diagResultItem.diagItem.sampleComment.length == 0)">
                <!--参考資料 start-->
                <div class="l-contentsMemo">
                  <div class="l-formGroup">
                    <div class="l-contentsMemo__title">
                      <label class="l-formGroup__label">参考資料URL</label>
                      <button v-if="!urlForms[0].viewFlag" class="link-arrow" @click="changeForm(true)">編集する</button>
                      <button v-else class="link-arrow" @click="changeForm(false)">編集を終わる</button>
                    </div>
                    <div v-for="(form, index) in urlForms" :key="index">
                      <div v-if="!urlForms[index].viewFlag" class="l-contentsMemo__body">
                        <div class="l-grayBox is-normal auto-height" style="height:300px;">
                          <p class="l-text" style="white-space: pre-line;" v-html="repalceLink(urlForms[index].content)"></p>
                        </div>
                      </div>
                      <TextArea v-if="urlForms[index].viewFlag" class="auto-height l-formGroup__textArea" style="height:300px;" v-model="urlForms[index].content" @input="() => isAnswerChanged = true"></TextArea>
                    </div>
                  </div>
                </div>
                <!--参考資料 end-->
              </div>

              <div style="width:50%;" v-if="diagResultItem.diagItem.sampleComment != null && diagResultItem.diagItem.sampleComment.length > 0">

                <div class="l-contentsMemo__title">
                  <label class="l-formGroup__label">現状/課題の例文</label>
                  <button class="link-arrow" @click="copyToClipboard(diagResultItem.diagItem.sampleComment)">コピーする</button>
                </div>

                <div class="l-contentsMemo__body">
                  <div class="l-grayBox is-normal"  style="height:300px;">
                    <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink($v.diagResultItem.$model.diagItem.sampleComment)"></p>
                  </div>
                </div>

              </div>
            </div> <!--l-contentsGrid2__item end -->

          </div>
          <div v-else>

                <div class="l-contentsMemo__title">
                  <label class="l-formGroup__label">現状/課題</label>
                  <button v-if="!isRemarksEditable" class="link-arrow" @click="changeRemarksEditable(true)">編集する</button>
                  <button v-if="isRemarksEditable" class="link-arrow" @click="changeRemarksEditable(false)">編集を終わる</button>
                </div>

                <div v-if="!isRemarksEditable" class="l-contentsMemo__body">
                  <div class="l-grayBox is-normal auto-height" style="height:300px;">
                    <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink($v.diagResultItem.$model.remarks)"></p>
                  </div>
                </div>

                <div v-if="isRemarksEditable" class="l-formGroup">
                  <textarea class="auto-height l-formGroup__textArea is-edit" style="height:300px;" v-model="$v.diagResultItem.$model.remarks" @input="() => isAnswerChanged = true"></textarea>
                </div>
                <ValidationErrorMessage v-show="$v.diagResultItem.remarks.$error && !$v.diagResultItem.remarks.maxLength" validation="maxLength" valueLength="500" />
          </div>
        </div>

        <div class="l-contentsSection">
        </div>

        <div class="l-contentsSection" v-if="hasRisk">
          <div class="l-contentsBox">
            <div class="l-contentsBox__header">
              <h4>課題タイトル <span>{{ diagResultItem.diagItem.task }}</span></h4>
            </div>
            <div class="l-contentsGrid2">
              <div class="l-contentsGrid2__item">
                <div>
                  <div class="l-formGroup">
                    <label class="l-formGroup__label">対応期限</label>
                    <div class="l-inputDate">
                      <DatePicker v-model="diagResultItem.dueDate" :value="diagResultItem.dueDate" @input="() => isAnswerChanged = true"></DatePicker>
                    </div>
                    <label class="l-checkbox">
                      <CheckBox v-model="diagResultItem.isHighPriority" :value="true"
                        :checked="diagResultItem.isHighPriority"
                        @input="() => isAnswerChanged = true"
                        labelText="優先度「高」"/>
                    </label>
                  </div>
                </div>
              </div>
              <div class="l-contentsGrid2__item">
                <div class="l-contentsMemo" v-if="!isIpo">
                  <div class="l-formGroup">
                    <div class="l-contentsMemo__title">
                      <label class="l-formGroup__label">改善の方向性</label>
                      <button v-if="!isCommentEditable" class="link-arrow" @click="changeCommentEditable(true)">編集する</button>
                      <button v-if="isCommentEditable" class="link-arrow" @click="changeCommentEditable(false)">編集を終わる</button>
                    </div>
                    <div v-if="!isCommentEditable" class="l-contentsMemo__body">
                      <div class="l-grayBox">
                        <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(diagResultItem.laborConsultantComment)"></p>
                      </div>
                    </div>
                    <TextArea v-if="isCommentEditable" class="l-formGroup__textArea" v-model="diagResultItem.laborConsultantComment" @input="() => isAnswerChanged = true"></TextArea>
                  </div>
                </div>
                <div class="l-contentsMemo" v-if="isIpo">
                  <div class="l-formGroup">
                    <div class="l-contentsMemo__title">
                      <label class="l-formGroup__label">改善の方向性</label>
                      <button v-if="!isCommentEditable" class="link-arrow" @click="changeCommentEditable(true)">編集する</button>
                      <button v-if="isCommentEditable" class="link-arrow" @click="changeCommentEditable(false)">編集を終わる</button>
                    </div>
                    <div v-if="!isCommentEditable" class="l-contentsMemo__body">
                      <div class="l-grayBox">
                        <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(diagResultItem.laborConsultantCommentForIpo)"></p>
                      </div>
                    </div>
                    <TextArea v-if="isCommentEditable" class="l-formGroup__textArea" v-model="diagResultItem.laborConsultantCommentForIpo" @input="() => isAnswerChanged = true"></TextArea>
                  </div>
                </div>
              </div> <!-- l-contentsGrid2__item end -->
            </div>
          </div>
        </div>
        <div class="l-contentsBox__bottom">
          <div class="btn-group">
            <div class="btn-basic is-inlne is-noborder js-cancel" @click="goDiagManagementList()"><a>一覧へ戻る</a></div>
            <div class="btn-basic is-inlne is-primary js-save" @click="beforeSave()"><a>保存</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="l-contents">
      <ul class="l-pageNav">
        <li @click="goDiagManagementDetail(previous.diagResultItemId)">
          <template v-if="previous.diagResultItemId">
            <a>{{ previousCheckItemLabel }}</a>
          </template>
        </li>
        <li @click="goDiagManagementList()"><a>診断管理</a></li>
        <li @click="goDiagManagementDetail(next.diagResultItemId)" >
          <template v-if="next.diagResultItemId">
            <a>{{ nextCheckItemLabel }}</a>
          </template>
        </li>
      </ul>
    </div>
    <div class="l-bgGray" v-if="isAdmin && (solutionList.length > 0)">
      <div class="l-contents">
        <h2 class="l-pageTitle"><img src="@/assets/img/common/icon-nav5_blue.svg" alt="">おすすめソリューション</h2>
          <ul class="l-solutionList">
            <li class="l-solutionList__item" v-for="solution in solutionList" :key="solution.solutionId" @click="goSolutionDetail(solution.solutionId)">
              <a>
                <div class="l-solutionList__img" :style="'background-image: url(' + solution.thumbNailImageFile + ');'"></div>
                <p class="l-solutionList__title">{{ solution.name }}</p>
                <p class="l-solutionList__text" style="overflow-wrap: normal; word-break: break-all; white-space: pre-line;">{{ solution.descriptionForList }}</p>
              </a>
            </li>
          </ul>
      </div>
    </div>
    <transition name="egovprovisionmodal-fade">
      <EgovProvisionsModal
        v-if="isShowEgovProvision"
        :itemId="diagResultItem.itemId"
        @hide-egov-provision-modal="showEgovProvision(false)"
      ></EgovProvisionsModal>
    </transition>
    <transition name="tutorialmodal-fade">
      <DiagManagementDetailTutorial
        v-show="isShowTutorial"
        @close-tutorial-modal="showTutorialModal(false)"
      ></DiagManagementDetailTutorial>
    </transition>
    <transition name="tutorialmodal-fade">
      <DiagManagementDetailSaveTutorial
        v-show="isShowSaveTutorial"
        @close-tutorial-modal="save()"
      ></DiagManagementDetailSaveTutorial>
    </transition>
  </div>
  </main>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';
import DiagHeaderNavigation from '@/components/parts/diag/DiagHeaderNavigation.vue';
import CheckBox from '@/components/parts/form/CheckBox.vue';
import RadioButton from '@/components/parts/form/RadioButton.vue';
import DatePicker from '@/components/parts/form/DatePicker.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import constant from '@/const';
import EgovProvisionsModal from '@/components/parts/master/EgovProvisionsModal.vue';
import { saveAs } from "file-saver";
import { maxLength } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import DiagNavigation from '@/components/parts/diag/DiagNavigation.vue';
import DiagManagementDetailTutorial from '@/components/parts/tutorial/DiagManagementDetailTutorial.vue';
import DiagManagementDetailSaveTutorial from '@/components/parts/tutorial/DiagManagementDetailSaveTutorial.vue';

export default {
  components: {
    Loading,
    DiagCorpHeader,
    DiagHeaderNavigation,
    CheckBox,
    RadioButton,
    DatePicker,
    TextArea,
    TextBox,
    EgovProvisionsModal,
    ValidationErrorMessage,
    DiagNavigation,
    DiagManagementDetailTutorial,
    DiagManagementDetailSaveTutorial,
  },
  mounted() {
    jQuery(function ($) {
      $(document).on('click', function() {
          $('.tooltip').fadeOut(200); // 画面のどこかがクリックされたときにツールチップを隠す
      });
    })
  },
    data() {
    return {
      isParamAccess: false,
      isProcessing: false,
      isShowEgovProvision: false,
      isShowTutorial: false,
      isShowSaveTutorial: false,
      diagResultItem: {
        diagItem: {
          checkItem: '',
          riskLevel: {
            name: ''
          },
          ipoImportance: {
            name: ''
          },
          guideCd: '',
          diagSection: {
            sectionNm: '',
          },
          diagSubSection: {
            subSectionNm: '',
          }
        },
        itemId: null,
      },
      previous: {
        diagResultItemId: null,
        checkItem: '',
      },
      next: {
        diagResultItemId: null,
        checkItem: '',
      },
      score: 0,
      totalScore: 0,
      selectList: constant.DIAG_ANSWER_VALUE,
      diagChartCategoryDetailLabelList: [],
      solutionList: [],
      isAnswerChanged: false,
      isAdmin: false,
      sortOrder: null,
      isCommentEditable: false,
      isRemarksEditable: false,
      urlForms: [],
    }
  },
  validations: {
    diagResultItem: {
      remarks: { maxLength: maxLength(500) }
    },
  },
  computed: {
    diagResultItemId() {
      return this.$store.getters['diag/getDiagResultItemId'];
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    diagTitle() {
      return this.$store.dispatch('diag/getTitle');
    },
    hasRisk() {
      return (this.diagResultItem.itemVal == '2' || this.diagResultItem.itemVal == '3');
    },
    previousCheckItemLabel() {
      if (!this.previous.diagResultItemId) return '';
      return (this.previous.checkItem.length > 20)
        ? (this.previous.checkItem).slice(0, 20) + '...'
        : this.previous.checkItem;
    },
    nextCheckItemLabel() {
      if (!this.next.diagResultItemId) return '';
      return (this.next.checkItem.length > 20)
        ? (this.next.checkItem).slice(0, 20) + '...'
        : this.next.checkItem;
    },
    diagManagementListSearchForm() {
      return this.$store.getters['diag/getDiagManagementListSearchForm'];
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
    corporateFeatureInfoLabels() {
      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
    },
  },
  watch: {
    // corpIdの監視　法人切替時に実行される
    async corpId() {
      if ( !this.isParamAccess ) {
        // Paramアクセスでない場合は、diagResultIdをクリアしてに遷移する
        // クリアしないとtopに遷移したときにdiagResultIdが引き継がれてしまう
        this.$store.dispatch('diag/setDiagResultId', null);
        this.$router.push({ name: 'diag-top' });
      }
    },
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.unLoadHandle);
  },
  created: async function () {
    this.isProcessing = true;

    // パラメータURLからのアクセスかどうかをフラグ値にする
    this.isParamAccess = ( this.$route.params.corpId != undefined && this.$route.params.diagResultId != undefined && this.$route.params.diagResultItemId != undefined );

    // パラメータURLからのアクセスの場合は引き継いだ変数値を設定する
    if (this.isParamAccess) {

      this.$store.dispatch('diag/setCorpId', this.$route.params.corpId);
      this.$store.dispatch('diag/setDiagResultId', this.$route.params.diagResultId);
      this.$store.dispatch('diag/setDiagResultItemId', this.$route.params.diagResultItemId);

      // パラメータのチェック
      await this.checkParams(this.$route.params);
    }else{
      await this.getDiagResultItem(this.diagResultItemId);
      this.showTutorialModal(this.$store.getters['auth/getUser'].tutorial.isShowDiagManagementDetailTutorial);
      const authority = await this.$store.dispatch('auth/getAuthority');
      this.isAdmin = authority.isAdmin;

      // パラメータURL空のアクセスフラグを解除する
      this.isParamAccess = false;
      this.isProcessing = false;
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isAnswerChanged && !to.query.usertype) {
      const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？")
      next(answer)
    } else {
      next();
    }
  },
  methods: {
    changeForm(flag){
      this.urlForms.forEach((form) => {
        form.viewFlag = flag;
      });
    },
    toggle(id) {
      var tooltip = $('#'+id);
      tooltip.fadeIn(200);
    },
    toggleb(id) {
      var tooltip = $('#'+id);
      tooltip.fadeOut(200);
    },
    async checkParams(params) {
      let res = await this.$axios.post('/ld/api/diag/checkParams', {
        corpId: params.corpId,
        diagResultId: params.diagResultId,
        diagResultItemId: params.diagResultItemId,
      });
      if (res.status===500){
        let res = await this.$axios.post('/ld/api/corporate/getClientCorporateList', {});
        if (res) {
          this.$store.dispatch('diag/setCorpId', res.data.corporateList[0].corpId);
          this.$store.dispatch('diag/setDiagResultId', null);
          this.$store.dispatch('diag/setDiagResultItemId', null);
          this.$toast.error('企業情報が見つからなかったので、Top画面に戻ります。');
          this.$router.push({ name: 'diag-top' });
        }
      }else{
        await this.getCorporateFeatureInfoLabels(this.corpId);
        await this.getDiagResultTitle(this.diagResultId);
        await this.getLatestDiagResultForCorporate(this.corpId, this.diagResultId);
        await this.getDiagResultItem(this.diagResultItemId);
        this.showTutorialModal(this.$store.getters['auth/getUser'].tutorial.isShowDiagManagementDetailTutorial);
        const authority = await this.$store.dispatch('auth/getAuthority');
        this.isAdmin = authority.isAdmin;

        // パラメータURL空のアクセスフラグを解除する
        this.isParamAccess = false;
        this.isProcessing = false;
      }

    },
    // 特徴データを取得して設定
    async getCorporateFeatureInfoLabels(corpId) {
      let res = await this.$axios.post('/ld/api/corporate/getCorporateFeatureInfoLabels', {
        corpId: corpId,
      });
      if (res) {
        this.$store.dispatch('diag/setCorporateFeatureInfoLabels', res.data.corporateFeatureInfoLabels);
      }
    },
    // 名前を設定するだけに取得している
    async getLatestDiagResultForCorporate(corpId, diagResultId = null) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/diag/getLatestDiagResultForCorporate', {
          corpId: corpId,
          diagResultId: diagResultId,
        });
        if (res.status==200) {
          this.$store.dispatch('diag/setCorpName', res.data.latestDiagResult.corpNm);
        }else{
          this.$toast.error(res.data.message);
        }
      }
    },
    async getDiagResultTitle(diagResultId) {
      if (diagResultId) {
        let res = await this.$axios.post('/ld/api/diag/getDiagResultTitle', {
          diagResultId: diagResultId,
        });
        if (res.status==200) {
          this.$store.dispatch('diag/setTitle', res.data.diagTitle);
        }else{
          this.$toast.error(res.data.message);
        }
      }
    },
    async getDiagResultItem(diagResultItemId) {
      let res = await this.$axios.post('/ld/api/diag/getDiagManagementDetail', {
        corpId: this.corpId,
        diagResultId: this.diagResultId,
        diagResultItemId: diagResultItemId,
        selectedDiagSectionIds: this.diagManagementListSearchForm.selectedDiagSectionIds,
        selectedItemVals: this.diagManagementListSearchForm.selectedItemVals,
        selectedVerifiedByLaborConsultant: this.diagManagementListSearchForm.selectedVerifiedByLaborConsultant,
        selectedRiskLevelIds: this.diagManagementListSearchForm.selectedRiskLevelIds,
        selectedIpoLevelIds: this.diagManagementListSearchForm.selectedIpoLevelIds,
        sortKey: this.diagManagementListSearchForm.sortKey,
      });
      if (res.status==200) {
        this.diagResultItem = res.data.diagResultItem;
        this.sortOrder = res.data.sortOrder;
        this.diagChartCategoryDetailLabelList = res.data.diagChartCategoryDetailLabelList;
        this.solutionList = res.data.solutionList;
        this.previous = res.data.previous;
        this.next = res.data.next;
        this.isIpo = res.data.isIpo;
        this.score = res.data.diagResultScore.answeredCount;
        this.totalScore = res.data.diagResultScore.totalCount;
        this.urlForms = res.data.urlForms;
        // 参考資料は1項目につき1つの欄として扱うため、データがなければ空の1件を用意する
        if (this.urlForms.length == 0) {
          this.urlForms.push({ content: "", viewFlag: false });
        }

        window.scrollTo({
          top: 0,
          behavior: "instant"
        });
      }else{
          this.$toast.error(res.data.message);
      }
    },
    async beforeSave() {
      this.isShowSaveTutorial = this.$store.getters['auth/getUser'].tutorial.isShowDiagManagementDetailSaveTutorial;
      if (this.isShowSaveTutorial) {
        this.showSaveTutorialModal(this.isShowSaveTutorial);
      } else {
        this.save();
      }
    },
    async save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        this.isAnswerChanged = false;
        let res = await this.$axios.post('/ld/api/diag/updateDiagResultItem', {
          diagResultId: this.diagResultId,
          diagResultItem: this.diagResultItem,
          corpId: this.corpId,
          urlForms: this.urlForms,
        });
        if (res.status === 200) {
          this.$toast.info('保存しました。');
          this.score = res.data.diagResult.score;
          this.totalScore = res.data.diagResult.totalScore;
          this.isCommentEditable = false;
          this.isRemarksEditable = false;
          this.urlForms.forEach((form) => {
            form.viewFlag = false;
          });
        } else {
          this.$toast.error(res.data.message);
        }
        this.isShowSaveTutorial = false;
        this.isProcessing = false;
      }
    },
    goSolutionDetail(solutionId) {
      this.$store.dispatch('solution/setSolutionId', solutionId);
      this.$router.push({ name: 'solution-detail' } );
    },
    showEgovProvision(value) {
      this.isShowEgovProvision = value;
    },
    async downloadGuideFile() {
      await saveAs('/ld/api/master/guide/downloadByGuideCd?guideCd=' + this.diagResultItem.diagItem.guideCd);
    },
    async goDiagManagementDetail(diagResultItemId) {
      if (this.isAnswerChanged) {
        const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？");
        if ( answer ) {
          this.isCommentEditable = false;
          this.isRemarksEditable = false;
          this.isAnswerChanged = false;
          this.$router.replace({path: '/diag/management/'+this.corpId+'/'+this.diagResultId+'/'+diagResultItemId+'/management/detailparam'});
          this.$store.dispatch('diag/setDiagResultItemId', diagResultItemId);
          await this.getDiagResultItem(diagResultItemId);
        }
      } else {
        this.isCommentEditable = false;
        this.isRemarksEditable = false;
        this.isAnswerChanged = false;
        this.$router.replace({path: '/diag/management/'+this.corpId+'/'+this.diagResultId+'/'+diagResultItemId+'/management/detailparam'});
        this.$store.dispatch('diag/setDiagResultItemId', diagResultItemId);
        await this.getDiagResultItem(diagResultItemId);
      }
    },
    goDiagManagementList() {
      this.$store.dispatch('diag/setDiagResultId', this.diagResultId);
      this.$router.push({ name: 'diag-management-list' });
    },
    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);
    },
    showTutorialModal(value) {
      this.isShowTutorial = value;
    },
    showSaveTutorialModal(value) {
      this.isShowSaveTutorial = value;
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    changeCommentEditable(value) {
      this.isCommentEditable = value;
    },
    changeRemarksEditable(value) {
      this.isRemarksEditable = value;
    },
    async unLoadHandle(evt) {
    if (this.isAnswerChanged) {
        evt.preventDefault()
        evt.returnValue = ''
      }
    },
    copyToClipboard (tagValue) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(tagValue);
        this.$toast.info('クリップボードに保存しました。');
      }
    },
  }
}

</script>

<style scoped>
.egovprovisionmodal-fade-enter-active {
  transition: all .2s ease;
}
.egovprovisionmodal-fade-leave-active {
  transition: all .2s ease;
}
.egovprovisionmodal-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.egovprovisionmodal-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.gray-out {
  pointer-events: none;
}

.gray-out a {
  border: 1px solid #6a6a6a ;
  color: #a9a9a9;
}

.tutorialmodal-fade-enter-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-leave-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.tutorialmodal-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
.input-urls {
  border-radius: 4px;
  border: 1px solid #bdbdbd;
  height: 28px;
  padding: 8px 10px;
  font-size: 1.5rem;
  font-family: 'Noto Sans JP', 'Helvetica Neue', 'Arial, sans-serif';
}
.input-urls-title {
  width: 160px;
}
.input-urls-url {
  width: 300px;
}
.input-urls-link {
  width: 460px;
  height: 28px;
  padding: 8px 10px;
  font-size: 1.5rem;
  font-family: 'Noto Sans JP', 'Helvetica Neue', 'Arial, sans-serif';
}
</style>
